import { DragOverlay as DndDragOverlay, type DragOverlayProps as DndDragOverlayProps } from '@dnd-kit/core';
import { Portal } from '@radix-ui/react-portal';
import type { ComponentPropsWithoutRef } from 'react';

type DragOverlayProps = DndDragOverlayProps & {
  /**
   * Container to portal into. Defaults to document.body.
   * This prop is passed to Radix UI Portal.Root.
   */
  container?: ComponentPropsWithoutRef<typeof Portal>['container'];
  /**
   * Whether to enable the portal. Defaults to true.
   */
  enablePortal?: boolean;
};

/**
 * DragOverlay component that renders dnd-kit's DragOverlay in a Radix UI Portal.
 * This is useful when DragOverlay is inside transformed containers (like modals/dialogs)
 * that can cause positioning issues.
 */
function DragOverlay({ container, enablePortal = true, children, ...props }: DragOverlayProps) {
  const overlay = <DndDragOverlay {...props}>{children}</DndDragOverlay>;

  if (enablePortal) {
    return <Portal container={container}>{overlay}</Portal>;
  }

  return overlay;
}

export { DragOverlay, type DragOverlayProps };
